<template>
    <div class="category-section">
        <h3 v-if="title" class="category-section__title">{{ title }}</h3>
        <div class="category-section__grid">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'CategorySection',
    props: {
        title: {
            type: String,
            required: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';

.category-section {
    &__title {
        display: none;

        @include on-desktop {
            display: block;
            font-size: urem(16);
            font-weight: 600;
            line-height: urem(24);
            color: rgba(19, 22, 20, 1);
            text-transform: uppercase;
            margin-top: 0;
            margin-bottom: urem(20);
            margin-bottom: urem(24);
        }
    }

    &__grid {
        display: flex;
        flex-wrap: wrap;
        gap: urem(16);
    }
}
</style>
